import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function basketReducer(state = initialState.basket, action) {
    switch (action.type) {
        case types.PURCHASE_ATTEMPT_SUCCESS:
            return {
                ...state,
                isPaymentAttemptSuccessful: true,
                purchaseAttemptMessages: action.purchaseAttemptMessages
            };
        case types.PURCHASE_ATTEMPT_ERROR:
            return {
                ...state,
                isPaymentAttemptSuccessful: false,
                userRegistrationMessages: action.purchaseAttemptMessages
            };
        default:
            return state;
    }
}
